import FollowUsBar from './FollowUsBar';

export default FollowUsBar;
